import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { REPORTS_TABS } from './reports.constants';
import { SessionService } from '@app/core/backend-adapter/session.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { IAccount, IAccountVendor } from '../acct-comps/accounts.interfaces';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent implements OnInit, OnDestroy {
  reportsTabs: typeof REPORTS_TABS = REPORTS_TABS;
  tabItems: MenuItem[];
  activeItem: MenuItem;
  private ngUnsubscribe$ = new Subject();
  private globalAccObject: any;
  public disableAppleInsights: boolean = false;
  public disableGoogleInsights: boolean = false;
  public disableYelpInsights: boolean = false;
  public disableBingInsights: boolean = false;

  constructor(private sessionService: SessionService) {}

  ngOnInit(): void {
    this.getCurrAccDetails();
    this.initReportsTab();
  }

  /**
   * @description Method to get global object of the current sihned in user.
   * @returns {void}
   */
  private getCurrAccDetails(): void {
    this.sessionService
      .getSelectedAccount$()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((res: IAccount) => {
        this.globalAccObject = typeof res?.global === 'string' ? JSON.parse(res?.global) : res?.global;
      });
  }

  /**
   * @description To initializa the Reports section tab menu items visibility, enable or disable them.
   * @returns {void}
   */
  private initReportsTab(): void {
    // Data parsed from account global (may be undefined if getCurrAccDetails hasn't fired yet)
    const parsedGlobal = this.globalAccObject;
    console.log('[Reports] initReportsTab – parsed global from account (res?.global):', parsedGlobal);

    const { publish: applePublishStatus = false, businessId: appleBusinessId = undefined } =
      parsedGlobal?.appleMaps || {};
    const {
      publish: yelpPublish = false,
      subscribeToLM: lmFlag = false,
      subscribeToYK: ykFlag = false,
    } = parsedGlobal?.yelp || {};
    const { publish: bingPublish = false } = parsedGlobal?.bing || {};

    console.log('[Reports] initReportsTab – values used for disabled logic:', {
      applePublishStatus,
      appleBusinessId,
      yelpPublish,
      lmFlag,
      ykFlag,
      bingPublish,
      isLocalOrDev: environment.name === 'local' || environment.name === 'development',
    });

    this.tabItems = Object.values(this.reportsTabs).map((tabName: string) => {
      return {
        label: tabName,
        disabled:
          tabName == this.reportsTabs.LOG ||
          (tabName === this.reportsTabs.YELP && !(yelpPublish && (lmFlag || ykFlag))) ||
          (tabName === this.reportsTabs.APPLE &&
            !(applePublishStatus && appleBusinessId) &&
            environment.name !== 'local' &&
            environment.name !== 'development') ||
          (tabName === this.reportsTabs.BING && !bingPublish),
        visible: tabName == this.reportsTabs.ACCURACY ? this.sessionService.hasPerm('report.accuracy', 'r') : true,
        command: (event) => {
          this.setActiveTab(event.item);
        },
      };
    });

    // activeItem: the tab that gets p-highlight (active). Inactive = any tab where activeItem !== item (reference).
    this.activeItem = this.tabItems[0];
    console.log('[Reports] initReportsTab – tabItems (label, disabled, visible):', this.tabItems.map((t) => ({ label: t.label, disabled: t.disabled, visible: t.visible })));
    console.log('[Reports] initReportsTab – initial activeItem (value used for active tab):', this.activeItem?.label, this.activeItem);
  }

  setActiveTab(item: MenuItem) {
    this.activeItem = item;
    console.log('[Reports] setActiveTab – new activeItem:', item?.label, item);
    console.log('[Reports] setActiveTab – activeItem === tabItems[i] for highlight; other tabs are inactive.');
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
